import React from 'react'
import AppHeader from '../sections/AppHeader'
import AppFooter from '../sections/AppFooter'


function AppLayout({children}) {
    return (
        
        <div className="main" >
            <AppHeader />
                {children}
            <AppFooter />
        </div>
    )
}

export default AppLayout